// One host-viewport observer per media query, shared by native drawer editors.
;(function (window) {
  'use strict';
  var lx = window.lx = window.lx || {};
  if (lx.formViewport) return;
  var queries = new Map();
  function watch(query, className) {
    var entry = queries.get(query);
    if (!entry) {
      var media;
      try { media = window.top.matchMedia(query); }
      catch (ignore) { media = window.matchMedia(query); }
      entry = {media:media, classes:new Set()};
      entry.update = function () {
        entry.classes.forEach(function (name) { document.body.classList.toggle(name, media.matches); });
      };
      media.addEventListener('change', entry.update);
      queries.set(query, entry);
    }
    entry.classes.add(className);
    entry.update();
  }
  lx.formViewport = {watch:watch};
  function ready() {
    watch('(max-width:767px)', 'lp-host-phone');
    watch('(min-width:768px)', 'lp-host-wide');
    watch('(min-width:768px) and (pointer:fine)', 'lp-host-desktop');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
  window.addEventListener('pagehide', function (event) {
    if (event.persisted) return;
    queries.forEach(function (entry) { entry.media.removeEventListener('change', entry.update); });
    queries.clear();
  });
}(window));
